export default "__VITE_ASSET__C1HzV36X__"